<header class="header">
   <card-header title="{{ 'CASES.CPSU.ADD_TO_CPSU' | translate }}">
   </card-header>
   <div class="header__actions">
      <form class="form" [formGroup]="cpsuFormAdd" style="width: 100%;">
         <div *ngIf="data.isFosterChild">
            <field-holder>
               <mat-form-field appearance="outline" (click)="selectMulti()">
                  <mat-label>{{'GLOBAL.CENTER' | translate}}</mat-label>
                  <mat-select formControlName="center" multiple required #multiSelect>
                     <input type="text" class="multi-input" autocomplete="off" matInput
                        placeholder="{{'GLOBAL.SEARCH_CENTERS' | translate}}" #multiSearch
                        (focus)="multiSelect.disabled = true" (focusout)="multiSelect.disabled = false"
                        (input)="onInputChange($event.target.value)" />
                     <mat-option #allSelectedCenters (click)="toggleAllSelectionCenter()" [value]="0">{{
                        'GLOBAL.ALL_CENTERS' | translate }}</mat-option>
                     <mat-option *ngFor="let value of filteredAllCenters" [value]="value?.id"
                        (click)="tosslePerOneCenter()">{{ value.name }}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="cpsuFormAdd.get('center').hasError('required')">
                     {{ "GLOBAL.CENTER_ERROR" | translate }}
                  </mat-error>
               </mat-form-field>
            </field-holder>
            <field-holder>
               <mat-form-field appearance="outline">
                  <mat-label>{{ 'CASES.CPSU.FOSTER_CHILD' | translate }}</mat-label>
                  <input matInput type="text" formControlName="fosterChildData" readonly>
               </mat-form-field>
            </field-holder>
            <field-holder>
               <mat-checkbox color="primary" class="form__checkbox" formControlName="insertFosterParentCheck"
                  *ngIf="cpsuFormAdd.get('center').value?.length === 1 && data.fosterParentData!= null && data.fosterParentData != ''">
                  {{ 'CASES.CPSU.INSERT_FOSTER_PARENT_WITH_CHILD' | translate }}
               </mat-checkbox>
            </field-holder>
            <field-holder>
               <mat-form-field appearance="outline" *ngIf="cpsuFormAdd.get('insertFosterParentCheck').value">
                  <mat-label>{{ 'CASES.CPSU.FOSTER_PARENT' | translate }}</mat-label>
                  <input matInput type="text" formControlName="fosterParentData" readonly>
               </mat-form-field>
            </field-holder>
         </div>
         <div *ngIf="!data.isFosterChild">
            <field-holder>
               <mat-form-field appearance="outline">
                  <mat-label>{{'GLOBAL.CENTER' | translate}}</mat-label>
                  <mat-select formControlName="center" required>
                     <mat-option *ngFor="let value of centers" [value]="value?.id">
                        {{ value.name }}
                     </mat-option>
                  </mat-select>
                  <mat-error *ngIf="cpsuFormAdd.get('center').hasError('required')">
                     {{ "GLOBAL.CENTER_ERROR" | translate }}
                  </mat-error>
               </mat-form-field>
            </field-holder>
            <field-holder>
               <mat-form-field appearance="outline">
                  <mat-label>{{ 'CASES.CPSU.FOSTER_PARENT' | translate }}</mat-label>
                  <input matInput type="text" formControlName="fosterParentData" readonly>
               </mat-form-field>
            </field-holder>
         </div>
         <form-footer>
            <button mat-stroked-button color="primary" class="form-footer__button" (click)="sendRequest()"
               [disabled]="!cpsuFormAdd.valid">
               {{ 'SIDEBAR_WIDGET.OTHER_INSTITUTIONS.SUBMIT' | translate }}
            </button>
            <button mat-stroked-button color="primary" mat-dialog-close (click)="closeDialog()"
               class="modal-footer__button modal-footer__button--secondary">
               {{ 'WARNING_DIALOG.CANCEL' | translate }}
            </button>
         </form-footer>
      </form>
   </div>
</header>